const trustItems = [
  { icon: "ri-shield-check-line", text: "Nur verifizierte Verkäufer" },
  { icon: "ri-image-line", text: "QC Fotos geprüft" },
  { icon: "ri-time-line", text: "Tägliche Updates" },
  { icon: "ri-eye-line", text: "Kostenlos durchstöbern" },
];

export default function TrustBar() {
  return (
    <section className="bg-background-50 border-b border-background-200/70">
      <div className="w-full px-4 md:px-8 lg:px-12 py-4 md:py-5">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {trustItems.map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-sm text-foreground-600">
              <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className={item.icon}></i>
              </span>
              <span className="whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}